<template>
  <div id="loading">
    <div class="LoadingBox">
      <div class="cssLoading">
        <div class="outer">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <p class="text">{{Msg}}</p>
      </div>
    </div>
  </div>
</template>

<script>
// import { setInterval } from 'timers'
export default {
  data () {
    return {
      Msg: '加载中...',
      conter: 0
    }
  },
  methods: {
    // changeText: function () {
    //   let _this = this
    //   _this.changeText = setInterval(() => {
    //     _this.conter++
    //     if (_this.conter >= 30) {
    //       clearInterval(_this.conter)
    //       _this.Msg = '请求超时，请刷新页面'
    //     }
    //   }, 1000)
    // }
  },
  mounted () {
    // this.changeText()
  }
}
</script>

<style>
.LoadingBox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: url("../assets/background_Gaussian_Blur.png") no-repeat center
    center;
  background-size: cover;
  z-index: 100000000;
}
.cssLoading,
.cssLoading .line {
  position: relative;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.cssLoading {
  display: block;
  font-size: 0;
  color: #fff;
  margin: auto;
}
.cssLoading .line {
  /* margin-top: 10px; */
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}
.cssLoading {
  position: absolute;
  top: calc(50% - 40px);
  left: 0;
  right: 0;
  margin: 0 auto;
  /* max-width: 160px; */
  width: 80px;
  /* height: 80px; */
  background: #c41335;
  text-align: center;
  border-radius: 5px;
  border-top: 1px solid transparent;
}
.cssLoading .text {
  display: inline-block;
  margin: 10px auto 10px auto;
  text-align: center;
  font-size: 13px;
  color: #fff;
}
.cssLoading .line {
  width: 4px;
  height: 32px;
  margin: 2px;
  margin-top: 10px;
  margin-bottom: 0;
  border-radius: 0;
  -webkit-animation: line-scale 1.2s infinite ease;
  -moz-animation: line-scale 1.2s infinite ease;
  -o-animation: line-scale 1.2s infinite ease;
  animation: line-scale 1.2s infinite ease;
}
.cssLoading .line:nth-child(1) {
  -webkit-animation-delay: -1.2s;
  -moz-animation-delay: -1.2s;
  -o-animation-delay: -1.2s;
  animation-delay: -1.2s;
}
.cssLoading .line:nth-child(2) {
  -webkit-animation-delay: -1.1s;
  -moz-animation-delay: -1.1s;
  -o-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.cssLoading .line:nth-child(3) {
  -webkit-animation-delay: -1s;
  -moz-animation-delay: -1s;
  -o-animation-delay: -1s;
  animation-delay: -1s;
}
.cssLoading .line:nth-child(4) {
  -webkit-animation-delay: -0.9s;
  -moz-animation-delay: -0.9s;
  -o-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.cssLoading .line:nth-child(5) {
  -webkit-animation-delay: -0.8s;
  -moz-animation-delay: -0.8s;
  -o-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
/*
 * Animation
 */
@-webkit-keyframes line-scale {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
    transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
  }
}
@-moz-keyframes line-scale {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
    -moz-transform: scaleY(0.4);
    transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
    -moz-transform: scaleY(1);
    transform: scaleY(1);
  }
}
@-o-keyframes line-scale {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
    -o-transform: scaleY(0.4);
    transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
    -o-transform: scaleY(1);
    transform: scaleY(1);
  }
}
@keyframes line-scale {
  0%,
  40%,
  100% {
    -webkit-transform: scaleY(0.4);
    -moz-transform: scaleY(0.4);
    -o-transform: scaleY(0.4);
    transform: scaleY(0.4);
  }
  20% {
    -webkit-transform: scaleY(1);
    -moz-transform: scaleY(1);
    -o-transform: scaleY(1);
    transform: scaleY(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue